var _defs, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPaymentsFlex(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 1200,
    height: 700,
    viewBox: "0 0 1200 700",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "bg",
    x1: 0,
    y1: 0,
    x2: 1200,
    y2: 700,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ECE8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D7D3FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "card",
    x1: 0,
    y1: 0,
    x2: 520,
    y2: 360,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFFFF",
    stopOpacity: 0.95
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7F8FF",
    stopOpacity: 0.95
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 1200,
    height: 700,
    rx: 48,
    fill: "url(#bg)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 110,
    y: 150,
    width: 520,
    height: 340,
    rx: 36,
    fill: "url(#card)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 160,
    y: 210,
    width: 260,
    height: 46,
    rx: 23,
    fill: "#E9EAF7"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 160,
    y: 280,
    width: 410,
    height: 22,
    rx: 11,
    fill: "#E0E2F3"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 160,
    y: 320,
    width: 360,
    height: 22,
    rx: 11,
    fill: "#E0E2F3"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 160,
    y: 360,
    width: 300,
    height: 22,
    rx: 11,
    fill: "#E0E2F3"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.92
  }, /*#__PURE__*/React.createElement("rect", {
    x: 720,
    y: 205,
    width: 350,
    height: 210,
    rx: 34,
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 760,
    y: 245,
    width: 210,
    height: 44,
    rx: 22,
    fill: "#F3F5FA"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1015,
    cy: 267,
    r: 22,
    fill: "#FCB402"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 760,
    y: 315,
    width: 270,
    height: 18,
    rx: 9,
    fill: "#E6EAF3"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 760,
    y: 350,
    width: 230,
    height: 18,
    rx: 9,
    fill: "#E6EAF3"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.75
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 915,
    cy: 505,
    r: 74,
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M915 458c33 0 60 21 60 46s-27 46-60 46-60-21-60-46 27-46 60-46z",
    fill: "#F3F5FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M880 496h70",
    stroke: "#D7DDEA",
    strokeWidth: 14,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M898 526h34",
    stroke: "#D7DDEA",
    strokeWidth: 14,
    strokeLinecap: "round"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaymentsFlex);
export default __webpack_public_path__ + "static/media/payments-flex.4ce37470c39200b719682d66f2606183.svg";
export { ForwardRef as ReactComponent };